export const blockIconsHomeCurtainsClosed = (
	<span className='material-symbols-outlined'>curtains_closed</span>
);
